import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  iconColumn: {
    fontSize: pxToRem(18),
    height: pxToRem(20),
    width: pxToRem(20),
    textAlign: 'center',
  },
  iconColumnHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(20),
        width: pxToRem(20),
        textAlign: 'center',
        top: '50%',
        transform: 'translateY(-50%)',
        position: 'relative',
        fontSize: pxToRem(16),
      },
    },
  },
  headerIcon: {
    position: 'relative',
    fontSize: pxToRem(16),
    maxHeight: pxToRem(16),
    maxWidth: pxToRem(16),
    verticalAlign: 'middle',
  },
});
